import React, { useState, useEffect, useReducer } from 'react'

import {
  withDataProvider,
  Show,
  CREATE,
  UPDATE
} from 'react-admin'

import Card from '@material-ui/core/Card'
import { createStyles } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import Button from '@material-ui/core/Button'
import moment from 'moment'
import Snackbar from '@material-ui/core/Snackbar'
import SnackbarMessage from '../../elements/SnackBarMessage'
import ApplicantExamStepper from './ApplicantExamStepper'
import ApplicanExamQuestion from './ApplicanExamQuestion'
import PageTitle from './PageTitle'
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import Cookies from 'js-cookie'
import AnswersTableExpertShow from "../../elements/AnswersTableExpertShow";
import axios from "axios";
import { Accordion, AccordionItem } from 'react-light-accordion';

const styles = () => createStyles({
  examTicketsTitle: {
    fontSize: 48,
    fontWeight: 400,
    marginBottom: 20
  },
  examBallsTitle: {
    fontSize: 38,
    fontWeight: 400,
    marginBottom: 20
  },
  expertsButton: {
    marginTop: 30,
    width: 210,
    marginLeft: 'auto'
  },
  wrap: {
    padding: '20px',
  },
  layout: {
    marginTop: '15px',
    padding: '20px'
  },
  head: {
    display: 'flex',
    padding: '20px 0 10px 20px',
    justifyContent: 'space-between',
  },
  group: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline'
  },
  main: {
    '& > div': {
      background: 'none',
      boxShadow: 'none'
    },
  },
  bottom: {
    display: 'flex',
    marginTop: '20px',
    justifyContent: 'space-between'
  },
  title: {
    margin: '0 0 20px 0',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  input: {
    margin: '0 0 20px 0',

  },
  groupButtons: {
    display: "flex",
    justifyContent: 'space-between'
  },
  tableBordered: {
    width: '100%',

    '& tr th': {
      padding: '7px 12px',
      border: '1px solid #ddd',
      backgroundColor: '#eee'
    },

    '& tr td': {
      border: '1px solid #ddd',
      padding: '7px 12px',
    },

    '& tr:last-child td': {
      border: '1px solid #ddd'
    }
  },
  textCenter: {
    textAlign: 'center'
  },
  small: {
    '& td': {
      fontSize: '14px'
    }
  },
  bgGray: {
    backgroundColor: '#eee'
  },
  textPrimary: {
    textAlign: 'center',
    color: '#b71c1c'
  },
})

let questionCount
let questionLeftCount

const ExamTicketCheckPage = ({dataProvider, classes, record}: any) => {
  const [showTableModal, setShowTableModal] = useState(false)
  const [selectedStatus, setSelectedStatus] = useState(0)
  const [selectedList] = useState([
    {
      id: 1,
      name: 'Не проверена',
      value: 'empty',
    },
    {
      id: 2,
      name: 'На проверке',
      value: 'verify',
    },
    {
      id: 3,
      name: 'В работе',
      value: 'work',
    },
    {
      id: 4,
      name: 'Проверена',
      value: 'complete',
    },
    {
      id: 5,
      name: 'Отменена',
      value: 'cancel',
    }
  ])
  const [segments, setSegments] = useState(record.segments)
  const [showDialog, setShowDialog] = useState(false)
  const [sending, setSending] = useState(false)
  const [showExpertModal, setShowExpertModal] = useState(false)
  const [expertModalData, setExpertModalData] = useState([])

  useEffect(() => {
    const idCurrentStatus = selectedList.filter(status => status.value === record.verifyStatus)[0].id

    setSelectedStatus(idCurrentStatus)
  }, [record])

  const getAssigner = ({ assign }) => (assign ? `${assign.surname} ${assign.name} ${assign.middleName}`.trim() : ' ')

  const role = Cookies.get('role')
  const userId = Cookies.get('userId')

  /**
   * Проверяте какие статусы и роли, и возвращает true, если нужно показать кнопку "Взять в работе".
   */
  const canShowWorkButton = () => {
    if (role === 'expertReviewer' && (record.verifyStatus === 'empty' || record.verifyStatus === 'verify')) {
      return true
    }

    if (role === 'censor' && (record.verifyStatus === 'empty' || record.verifyStatus === 'verify')) {
      return true
    }

    return false
  }

  useEffect(() => {
    setShowDialog(canShowWorkButton())
  }, [])

  const handleChange = async event => {
    setSelectedStatus(event.target.value)
    const currentStatus = selectedList.filter(item => item.id === event.target.value)[0].value

    await dataProvider(UPDATE, 'exam-tickets', {
      id: record.id,
      data: {
        verifyStatus: currentStatus
      }
    })
  }

  /**
   * Изменяет статус проверки.
   * @param status
   */
  const setCheckStatus = async (status) => {
    setSelectedStatus(status)

    await dataProvider(UPDATE, 'exam-tickets', {
      id: record.id,
      data: {
        verifyStatus: status
      }
    })
  }

  /**
   * Показывает оценки эксперта с выборанной позицией.
   * @param expertPosition
   */
  const showExpertModalDialog = (expertPosition) => {
    const experts = record.experts.filter((item) => {
      return item.position == expertPosition
    })

    const params = {
      token: Cookies.get('token'),
      workId: record.id,
      expertId: experts[0].id
    }

    const queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&')

    axios.get('/expert-tickets/balls-info?' + queryString)
      .then((response) => {
        const data = response.data
        setExpertModalData(data)
        setShowExpertModal(true)
      })
  }

  /**
   * Возвращает true, если нужно показать кнопку просмотра оценок другого эксперта.
   * @param expertPosition
   */
  const showExpertButton = (expertPosition) => {
    const currentExperts = record.experts.filter((item) => item.id == userId)

    if (currentExperts[0].position < 6) {
      return false
    }

    const experts = record.experts.filter((item) => {
      return item.position == expertPosition
    })

    return experts.length > 0;
  }

  return (
    <>
      <Card className={classes.wrap}>
        <h2 className={classes.title}>{`Информация об экзаменационной работе №${record.ticket.number}`}</h2>
        <Grid container spacing={8}>
          <Grid item xs={3}>
            <TextField
              className={classes.input}
              label="Назначен на"
              disabled
              value={getAssigner(record)}
              fullWidth
            />
          </Grid>
          <Grid item xs={2}>
            <TextField
              className={classes.input}
              label="Дата назначние проверки"
              disabled
              value={record.assignedAt || ' '}
              fullWidth
            />
          </Grid>
          <Grid item xs={2}>
            <TextField
              className={classes.input}
              label="Дата экзамена"
              disabled
              value={moment(record.exam.examDate).format('DD.MM.YYYY')}
              fullWidth
            />
          </Grid>
        </Grid>
        <Grid container spacing={8}>
          <Grid item xs={3}>
            <TextField
              className={classes.input}
              label="Уровень"
              disabled
              value={record.exam.level.name}
              fullWidth
            />
          </Grid>
          <Grid item xs={5}>
            <TextField
              className={classes.input}
              label="Модуль"
              disabled
              value={record.exam.modules[0].name}
              fullWidth
            />
          </Grid>
        </Grid>
        <Grid container spacing={8}>
          <Grid item xs={4}>
            {questionCount && (
              <TextField
                className={classes.input}
                label="Прогресс"
                disabled
                fullWidth
                value={`${questionCount - questionLeftCount} проверено из ${questionCount}`}
                InputProps={{
                  readOnly: true,
                }}
              />
            )}
          </Grid>
          <Grid item xs={2}>
            <div style={{
              paddingTop: '16px'
            }}
            >
              <Select
                id="status"
                onChange={handleChange}
                value={selectedStatus}
                fullWidth
                disabled={true}
              >
                {selectedList && selectedList.map(expert => (
                  <MenuItem value={expert.id}>{expert.name}</MenuItem>
                ))}
              </Select>
            </div>
          </Grid>
          <Grid item xs={2}>
            <TextField
              className={classes.input}
              label="Общая оценка"
              disabled
              value={record.mark}
              fullWidth
            />
          </Grid>
        </Grid>

        <div className={classes.group}>
          <div>
            {(selectedStatus === 1 || selectedStatus === 2) && (
              <p>
                <Button onClick={() => setCheckStatus('work')} color="primary" variant="contained" className={classes.button}>Взять в работу</Button>
              </p>
            )}
            {selectedStatus === 3 && (
              <div className={classes.groupButtons}>
                <Button onClick={() => setCheckStatus('complete')} color="primary" variant="contained" className={classes.button}>Закончить</Button>
              </div>
            )}
          </div>
          {record.exam.level.id > 1 && (
            <div>
              <Button disabled={!showExpertButton(6)} onClick={() => showExpertModalDialog(6)} color="default" variant="contained" className={classes.button}>Эксперт 1 (оценки)</Button>
              <Button disabled={!showExpertButton(7)} onClick={() => showExpertModalDialog(7)} color="default" variant="contained" className={classes.button}>Эксперт 2 (оценки)</Button>
              <Button disabled={!showExpertButton(8)} onClick={() => showExpertModalDialog(8)} color="default" variant="contained" className={classes.button}>Эксперт 3 (оценки)</Button>
            </div>
          )}
        </div>

        <Dialog open={showDialog} onClose={() => setShowDialog(false)} aria-labelledby="form-dialog-title">
          <DialogTitle>Начало работы</DialogTitle>
          <DialogContent>
            <p>Необходимо нажать кнопку "Взять в работу".</p>
            <Button onClick={() => setShowDialog(false)} color="secondary" variant="contained">Понятно</Button>
          </DialogContent>
        </Dialog>

        <Dialog open={showExpertModal} onClose={() => setShowExpertModal(false)} aria-labelledby="form-dialog-title" maxWidth="md">
          <DialogTitle>Оценки другого эксперта</DialogTitle>
          <DialogContent>
            <Accordion atomic={true}>
              {expertModalData.map((segment, index) => (
                <AccordionItem title={"Сегмент " + (index + 1)}>
                  {segment.map((question, questionIndex) => (
                   <p>
                     <h4>Вопрос {questionIndex + 1}</h4>
                     <AnswersTableExpertShow data={question.list} totalBalls={question.balls} factBalls={question.expertMark.mark} />
                   </p>
                  ))}
                </AccordionItem>
              ))}
            </Accordion>
          </DialogContent>
        </Dialog>

      </Card>

      <ExamTicketQuestion dataProvider={dataProvider} classes={classes} record={record} />
    </>
  )
}

function reducer(state, { type, payload }) {
  switch (type) {
    case 'set_segments':
      return payload.segments
    case 'add_mark':
      return [...state.map(item => {
        if (payload.segmentId === item.id) {
          return {
            ...item,
            expertMark: {
              ...item.expertMark,
              mark: payload.expertMark
            }
          }
        }
        return item
      })]
    case 'set_chechk':
      return [...state.map(item => {
        if (payload.segmentId === item.id) {
          return {
            ...item,
            expertMark: {
              ...item.expertMark,
              isCreated: true
            }
          }
        }
        return item
      })]
    case 'add_comment':
      return [...state.map(item => {
        if (payload.segmentId === item.id) {
          return {
            ...item,
            comments: [...item.comments, payload.comment]
          }
        }
        return item
      })]
    case 'add_mark_to_question':
      return [...state.map(item => {
        if (payload.segmentId === item.id) {
          return {
            ...item,
            case: {
              ...item.case,
              questions: item.case.questions.map(question => {
                if (payload.questionId === question.id) {
                  return {
                    ...question,
                    expertMark: {
                      ...question.expertMark,
                      mark: payload.expertMark
                    }
                  }
                }
                return question
              })
            }
          }
        }
        return item
      })]
    case 'update_balls_expert':
      return [...state.map(item => {
        if (payload.segmentId === item.id) {
          return {
            ...item,
            case: {
              ...item.case,
              questions: item.case.questions.map(question => {
                if (payload.questionId === question.id) {
                  return {
                    ...question,
                    ballsInfo: payload.ballsInfo
                  }
                }
                return question
              })
            }
          }
        }
        return item
      })]
    case 'add_сomment_to_question':
      return [...state.map(item => {
        if (payload.segmentId === item.id) {
          return {
            ...item,
            case: {
              ...item.case,
              questions: item.case.questions.map(question => {
                if (payload.questionId === question.id) {
                  return {
                    ...question,
                    comments: [...question.comments, payload.comment]
                  }
                }
                return question
              })
            }
          }
        }
        return item
      })]
    default:
      throw new Error()
  }
}

const ExamTicketQuestion = ({ dataProvider, classes, record }: any) => {
  const [completeQuestion, setCompleteQuestion] = useState([])
  const [currentPostion, setCurrentPostion] = useState(1)
  const [activeQuestion, setActiveQuestion] = useState()
  const [questionList, dispatch] = useReducer(reducer, record.segments)
  const [ballsResult, setBallsResult] = useState([])

  const [showModal, setShowModal] = useState<boolean>(false)

  const limitRecursion = 50
  let counter = 0

  const getNextElement = currentPositionNumber => {
    if (questionList) {
      const currentElement = questionList[currentPositionNumber]

      if (++counter > limitRecursion) {
        counter = 0
        return currentElement
      }

      if (!currentElement) {
        return getNextElement(0)
      }

      if (!currentElement.expertMark.isCreated) {
        setCurrentPostion(currentPositionNumber + 1)
        return currentElement
      }

      return getNextElement(currentPositionNumber + 1)
    }
  }

  useEffect(() => {
    if (record.segments) {
      dispatch({ type: 'set_segments', payload: { segments: record.segments } })

      const answeredQuestionList = record.segments.filter(question => question.expertMark.isCreated)
      setCompleteQuestion(answeredQuestionList)
      setActiveQuestion(record.segments[0])
    }
  }, [record.segments])

  useEffect(() => {
    if (questionList && activeQuestion) {
      const newActiveQuestion = questionList.filter(question => {
        if (question.id === activeQuestion.id) {
          return question
        }
      })
      setActiveQuestion(newActiveQuestion[0])
    }
  }, [questionList])

  // заполняем результаты оценочного листа
  useEffect(() => {
    if (questionList) {
      let list = []

      questionList.map((question, row) => {
        list.push(question.ballsResult)

        // проверяем, всё ли заполнено
        question.case.questions.map((item, column) => {
          if (list[row][column] === undefined) {
            list[row][column] = 0
          }
        })
      })

      setBallsResult(list)
    }
  }, [questionList])

  if (!questionList) return null

  questionCount = questionList.length
  questionLeftCount = questionCount - completeQuestion.length

  const getCurrentElementPosition = () => {
    const searchTerm = activeQuestion.id
    let index = -1
    for (let i = 0, len = questionList.length; i < len; i++) {
      if (questionList[i].id === searchTerm) {
        index = i
        break
      }
    }

    return index + 1
  }

  /**
   * Обновляет оценочный лист.
   * @param currentMark
   */
  const updateBallsResult = (currentMark) => {
    const position = getCurrentElementPosition() - 1
    let list = ballsResult

    currentMark.map((item, index) => {
      list[position][index] = parseFloat(item.expertMark.mark)
    })

    setBallsResult(list)
  }

  /**
   * Переход к следующему заданию.
   */
  const nextQuestion = () => {
    const nextElem = getNextElement(getCurrentElementPosition())

    if (nextElem) setActiveQuestion(nextElem)
  }

  /**
   * Сохраняет оценку эксперта.
   */
  const saveQuestion = async () => {
    const activeQuestionId = activeQuestion.id
    setCompleteQuestion([
      ...completeQuestion.filter(q => (q.activeQuestionId || q.id) !== activeQuestionId),
      { activeQuestionId }
    ])

    if (questionLeftCount >= 1 && activeQuestion.type === 'test') {
      if (activeQuestion.expertMark.mark === null) {
        setShowModal(true)
      } else {
        dispatch({ type: 'set_chechk', payload: { segmentId: activeQuestion.id } })
        nextQuestion()
      }
    }
    try {
      if (activeQuestion.type === 'case') {
        const currentMark = activeQuestion.case.questions.map(question => {
          return {
            expertMark: question.expertMark,
            ballsInfo: question.ballsInfo
          }
        })

        // обновляем оценочный лист
        updateBallsResult(currentMark)

        const markMark = currentMark.map(expertMark => expertMark.expertMark.mark).some(mark => mark === null)
        if (markMark) {
          setShowModal(true)
        } else {
          dispatch({ type: 'set_chechk', payload: { segmentId: activeQuestion.id } })
          nextQuestion()
        }

        await dataProvider(CREATE, 'exam-tickets', {
          id: record.id,
          data: currentMark,
        })

      } else {
        await dataProvider(CREATE, 'exam-tickets', {
          id: record.id,
          data: activeQuestion.expertMark,
        })
      }
    } catch (e) {
      console.error(e)
    }
    dataProvider(UPDATE, 'exam-tickets', {
      id: record.id,
      data: {}
    })
  }

  return (
    <>
      <PageTitle title={`Вопрос ${currentPostion}`} />
      <ApplicantExamStepper
        questionList={questionList}
        activeQuestionId={activeQuestion && activeQuestion.id}
        setActiveQuestion={setActiveQuestion}
        setCurrentPosition={setCurrentPostion}
        ballsResult={ballsResult}
      />

      {activeQuestion && (<ApplicanExamQuestion dispatch={dispatch} activeQuestion={activeQuestion} ticketId={record.ticket.id} />)}

      <div className={classes.bottom}>
        <Button
          variant="contained"
          onClick={nextQuestion}
        >
          Пропустить
        </Button>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={showModal}
          onClose={() => setShowModal(false)}
          autoHideDuration={4000}
          color="primary"
        >
          <SnackbarMessage
            message="Вы поставили не все баллы"
          />
        </Snackbar>
        <Button
          variant="contained"
          color="primary"
          onClick={saveQuestion}
        >
          Оценить ответ
        </Button>
      </div>
    </>
  )
}

const ExamTicketCheck = withStyles(styles)(({
                                              record, dataProvider, classes, ...props
                                            }: any) => (
  <>
    <Typography
      variant="title"
      className={classes.examTicketsTitle}
    >
      Список работ на проверку
    </Typography>
    <Show title="test" {...props} className={classes.main}>
      <ExamTicketCheckPage classes={classes} dataProvider={dataProvider} />
    </Show>
  </>
))

export default withDataProvider(withDataProvider(ExamTicketCheck))
